var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNySanta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 102,
    viewBox: "0 0 218 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_901_1790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.9053 37.3984H69.2852V40.7984H65.9053V37.3984Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2881 37.3984H72.668V40.7984H69.2881V37.3984Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8077 23.8008H86.1875V27.2008H82.8077V23.8008Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1866 23.8008H89.5664V27.2008H86.1866V23.8008Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5655 20.3984H92.9453V23.7984H89.5655V20.3984Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9444 20.3984H96.3242V23.7984H92.9444V20.3984Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4873 51H38.8672V54.4H35.4873V51Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8702 51H42.25V54.4H38.8702V51Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2491 51H45.6289V54.4H42.2491V51Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.628 51H49.0078V54.4H45.628V51Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3858 47.6016H55.7656V51.0016H52.3858V47.6016Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7686 47.6016H59.1484V51.0016H55.7686V47.6016Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1475 44.1992H62.5273V47.5992H59.1475V44.1992Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5264 40.8008H65.9062V44.2008H62.5264V40.8008Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.667 34H76.0469V37.4H72.667V34Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0459 30.6016H79.4258V34.0016H76.0459V30.6016Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4248 27.1992H82.8047V30.5992H79.4248V27.1992Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7061 20.3984H103.086V23.7984H99.7061V20.3984Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.085 20.3984H106.465V23.7984H103.085V20.3984Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7295 47.6016H32.1094V51.0016H28.7295V47.6016Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1084 47.6016H35.4883V51.0016H32.1084V47.6016Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0069 47.6016H52.3867V51.0016H49.0069V47.6016Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3272 20.3984H99.707V23.7984H96.3272V20.3984Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.085 17H106.465V20.4H103.085V17Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.464 17H109.844V20.4H106.464V17Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.847 17H113.227V20.4H109.847V17Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.226 17H116.605V20.4H113.226V17Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.605 17H119.984V20.4H116.605V17Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.983 17H123.363V20.4H119.983V17Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.366 20.3984H126.746V23.7984H123.366V20.3984Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.366 17H126.746V20.4H123.366V17Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.745 20.3984H130.125V23.7984H126.745V20.3984Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.124 20.3984H133.504V23.7984H130.124V20.3984Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.000938654 23.7969H3.37891V27.1969H-0.000938654V23.7969Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.000938654 20.3984H3.37891V23.7984H-0.000938654V20.3984Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.37797 27.1992H6.75781V30.5992H3.37797V27.1992Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75687 40.7969H10.1367V44.1969H6.75687V40.7969Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75687 37.3984H10.1367V40.7984H6.75687V37.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75687 30.5977H10.1367V33.9977H6.75687V30.5977Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1397 40.7969H13.5195V44.1969H10.1397V40.7969Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1397 37.3984H13.5195V40.7984H10.1397V37.3984Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1397 30.5977H13.5195V33.9977H10.1397V30.5977Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1397 27.1992H13.5195V30.5992H10.1397V27.1992Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1397 23.7969H13.5195V27.1969H10.1397V23.7969Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5186 85H16.8984V88.4H13.5186V85Z",
    fill: "#C1734C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5186 81.5977H16.8984V84.9977H13.5186V81.5977Z",
    fill: "#C1734C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5186 78.1992H16.8984V81.5992H13.5186V78.1992Z",
    fill: "#C1734C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5186 74.7969H16.8984V78.1969H13.5186V74.7969Z",
    fill: "#C1734C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5186 40.7969H16.8984V44.1969H13.5186V40.7969Z",
    fill: "#C1734C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5186 37.3984H16.8984V40.7984H13.5186V37.3984Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5186 34H16.8984V37.4H13.5186V34Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5186 30.5977H16.8984V33.9977H13.5186V30.5977Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5186 27.1992H16.8984V30.5992H13.5186V27.1992Z",
    fill: "#C1734C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8975 95.1992H20.2773V98.5992H16.8975V95.1992Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8975 91.7969H20.2773V95.1969H16.8975V91.7969Z",
    fill: "#C1734C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8975 88.3984H20.2773V91.7984H16.8975V88.3984Z",
    fill: "#C1734C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8975 85H20.2773V88.4H16.8975V85Z",
    fill: "#C1734C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8975 71.3984H20.2773V74.7984H16.8975V71.3984Z",
    fill: "#C1734C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8975 68H20.2773V71.4H16.8975V68Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8975 64.5977H20.2773V67.9977H16.8975V64.5977Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8975 61.1992H20.2773V64.5992H16.8975V61.1992Z",
    fill: "#F7B88B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8975 57.7969H20.2773V61.1969H16.8975V57.7969Z",
    fill: "#F7B88B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8975 54.3984H20.2773V57.7984H16.8975V54.3984Z",
    fill: "#F7B88B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8975 51H20.2773V54.4H16.8975V51Z",
    fill: "#F7B88B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8975 47.5977H20.2773V50.9977H16.8975V47.5977Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8975 44.1992H20.2773V47.5992H16.8975V44.1992Z",
    fill: "#C1734C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8975 40.7969H20.2773V44.1969H16.8975V40.7969Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8975 37.3984H20.2773V40.7984H16.8975V37.3984Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8975 34H20.2773V37.4H16.8975V34Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8975 30.5977H20.2773V33.9977H16.8975V30.5977Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8975 27.1992H20.2773V30.5992H16.8975V27.1992Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8975 23.7969H20.2773V27.1969H16.8975V23.7969Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2764 71.3984H23.6562V74.7984H20.2764V71.3984Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2764 68H23.6562V71.4H20.2764V68Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2764 64.5977H23.6562V67.9977H20.2764V64.5977Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2764 61.1992H23.6562V64.5992H20.2764V61.1992Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2764 57.7969H23.6562V61.1969H20.2764V57.7969Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2764 54.3984H23.6562V57.7984H20.2764V54.3984Z",
    fill: "#F7B88B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2764 51H23.6562V54.4H20.2764V51Z",
    fill: "#F7B88B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2764 47.5977H23.6562V50.9977H20.2764V47.5977Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2764 44.1992H23.6562V47.5992H20.2764V44.1992Z",
    fill: "#C1734C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2764 40.7969H23.6562V44.1969H20.2764V40.7969Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2764 37.3984H23.6562V40.7984H20.2764V37.3984Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2764 34H23.6562V37.4H20.2764V34Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2764 30.5977H23.6562V33.9977H20.2764V30.5977Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6592 95.1992H27.0391V98.5992H23.6592V95.1992Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6592 91.7969H27.0391V95.1969H23.6592V91.7969Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6592 88.3984H27.0391V91.7984H23.6592V88.3984Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6592 85H27.0391V88.4H23.6592V85Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6592 81.5977H27.0391V84.9977H23.6592V81.5977Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6592 78.1992H27.0391V81.5992H23.6592V78.1992Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6592 74.7969H27.0391V78.1969H23.6592V74.7969Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6592 71.3984H27.0391V74.7984H23.6592V71.3984Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6592 68H27.0391V71.4H23.6592V68Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6592 64.5977H27.0391V67.9977H23.6592V64.5977Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6592 61.1992H27.0391V64.5992H23.6592V61.1992Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6592 57.7969H27.0391V61.1969H23.6592V57.7969Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6592 54.3984H27.0391V57.7984H23.6592V54.3984Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6592 51H27.0391V54.4H23.6592V51Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6592 47.5977H27.0391V50.9977H23.6592V47.5977Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6592 44.1992H27.0391V47.5992H23.6592V44.1992Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6592 40.7969H27.0391V44.1969H23.6592V40.7969Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6592 37.3984H27.0391V40.7984H23.6592V37.3984Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6592 34H27.0391V37.4H23.6592V34Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6592 30.5977H27.0391V33.9977H23.6592V30.5977Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6592 27.1992H27.0391V30.5992H23.6592V27.1992Z",
    fill: "#C1734C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0381 71.3984H30.418V74.7984H27.0381V71.3984Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0381 68H30.418V71.4H27.0381V68Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0381 64.5977H30.418V67.9977H27.0381V64.5977Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0381 61.1992H30.418V64.5992H27.0381V61.1992Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0381 57.7969H30.418V61.1969H27.0381V57.7969Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0381 54.3984H30.418V57.7984H27.0381V54.3984Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0381 51H30.418V54.4H27.0381V51Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0381 47.5977H30.418V50.9977H27.0381V47.5977Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0381 44.1992H30.418V47.5992H27.0381V44.1992Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0381 40.7969H30.418V44.1969H27.0381V40.7969Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0381 37.3984H30.418V40.7984H27.0381V37.3984Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0381 34H30.418V37.4H27.0381V34Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0381 30.5977H30.418V33.9977H27.0381V30.5977Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0381 27.1992H30.418V30.5992H27.0381V27.1992Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0381 23.7969H30.418V27.1969H27.0381V23.7969Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.417 71.3984H33.7969V74.7984H30.417V71.3984Z",
    fill: "#C1734C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.417 68H33.7969V71.4H30.417V68Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.417 64.5977H33.7969V67.9977H30.417V64.5977Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.417 61.1992H33.7969V64.5992H30.417V61.1992Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.417 57.7969H33.7969V61.1969H30.417V57.7969Z",
    fill: "#F7B88B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.417 54.3984H33.7969V57.7984H30.417V54.3984Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.417 30.5977H33.7969V33.9977H30.417V30.5977Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7959 71.3984H37.1758V74.7984H33.7959V71.3984Z",
    fill: "#C1734C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7959 68H37.1758V71.4H33.7959V68Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7959 64.5977H37.1758V67.9977H33.7959V64.5977Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7959 61.1992H37.1758V64.5992H33.7959V61.1992Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7959 57.7969H37.1758V61.1969H33.7959V57.7969Z",
    fill: "#F7B88B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7959 54.3984H37.1758V57.7984H33.7959V54.3984Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7959 30.5977H37.1758V33.9977H33.7959V30.5977Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7959 27.1992H37.1758V30.5992H33.7959V27.1992Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7959 23.7969H37.1758V27.1969H33.7959V23.7969Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1787 71.3984H40.5586V74.7984H37.1787V71.3984Z",
    fill: "#C1734C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1787 68H40.5586V71.4H37.1787V68Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1787 64.5977H40.5586V67.9977H37.1787V64.5977Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1787 61.1992H40.5586V64.5992H37.1787V61.1992Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1787 57.7969H40.5586V61.1969H37.1787V57.7969Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1787 54.3984H40.5586V57.7984H37.1787V54.3984Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1787 30.5977H40.5586V33.9977H37.1787V30.5977Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5577 71.3984H43.9375V74.7984H40.5577V71.3984Z",
    fill: "#C1734C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5577 68H43.9375V71.4H40.5577V68Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5577 64.5977H43.9375V67.9977H40.5577V64.5977Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5577 61.1992H43.9375V64.5992H40.5577V61.1992Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5577 57.7969H43.9375V61.1969H40.5577V57.7969Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5577 54.3984H43.9375V57.7984H40.5577V54.3984Z",
    fill: "#F7B88B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5577 27.1992H43.9375V30.5992H40.5577V27.1992Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9366 71.3984H47.3164V74.7984H43.9366V71.3984Z",
    fill: "#C1734C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9366 68H47.3164V71.4H43.9366V68Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9366 64.5977H47.3164V67.9977H43.9366V64.5977Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9366 61.1992H47.3164V64.5992H43.9366V61.1992Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9366 57.7969H47.3164V61.1969H43.9366V57.7969Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9366 54.3984H47.3164V57.7984H43.9366V54.3984Z",
    fill: "#F7B88B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9366 23.7969H47.3164V27.1969H43.9366V23.7969Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9366 20.3984H47.3164V23.7984H43.9366V20.3984Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3155 71.3984H50.6953V74.7984H47.3155V71.3984Z",
    fill: "#C1734C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3155 68H50.6953V71.4H47.3155V68Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3155 64.5977H50.6953V67.9977H47.3155V64.5977Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3155 61.1992H50.6953V64.5992H47.3155V61.1992Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3155 57.7969H50.6953V61.1969H47.3155V57.7969Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3155 54.3984H50.6953V57.7984H47.3155V54.3984Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6983 74.7969H54.0781V78.1969H50.6983V74.7969Z",
    fill: "#C1734C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6983 71.3984H54.0781V74.7984H50.6983V71.3984Z",
    fill: "#C1734C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6983 68H54.0781V71.4H50.6983V68Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6983 64.5977H54.0781V67.9977H50.6983V64.5977Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6983 61.1992H54.0781V64.5992H50.6983V61.1992Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6983 57.7969H54.0781V61.1969H50.6983V57.7969Z",
    fill: "#F7B88B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6983 54.3984H54.0781V57.7984H50.6983V54.3984Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0772 78.1992H57.457V81.5992H54.0772V78.1992Z",
    fill: "#C1734C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0772 74.7969H57.457V78.1969H54.0772V74.7969Z",
    fill: "#C1734C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0772 71.3984H57.457V74.7984H54.0772V71.3984Z",
    fill: "#C1734C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0772 68H57.457V71.4H54.0772V68Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0772 64.5977H57.457V67.9977H54.0772V64.5977Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0772 61.1992H57.457V64.5992H54.0772V61.1992Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0772 57.7969H57.457V61.1969H54.0772V57.7969Z",
    fill: "#F7B88B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0772 54.3984H57.457V57.7984H54.0772V54.3984Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4561 95.1992H60.8359V98.5992H57.4561V95.1992Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5967 98.5977H70.9766V101.998H67.5967V98.5977Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6592 98.5977H27.0391V101.998H23.6592V98.5977Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4561 91.7969H60.8359V95.1969H57.4561V91.7969Z",
    fill: "#C1734C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4561 88.3984H60.8359V91.7984H57.4561V88.3984Z",
    fill: "#C1734C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4561 85H60.8359V88.4H57.4561V85Z",
    fill: "#C1734C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4561 81.5977H60.8359V84.9977H57.4561V81.5977Z",
    fill: "#C1734C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4561 78.1992H60.8359V81.5992H57.4561V78.1992Z",
    fill: "#C1734C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4561 74.7969H60.8359V78.1969H57.4561V74.7969Z",
    fill: "#C1734C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4561 71.3984H60.8359V74.7984H57.4561V71.3984Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4561 68H60.8359V71.4H57.4561V68Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4561 64.5977H60.8359V67.9977H57.4561V64.5977Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4561 61.1992H60.8359V64.5992H57.4561V61.1992Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4561 57.7969H60.8359V61.1969H57.4561V57.7969Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4561 54.3984H60.8359V57.7984H57.4561V54.3984Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.835 74.7969H64.2148V78.1969H60.835V74.7969Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.835 71.3984H64.2148V74.7984H60.835V71.3984Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.835 68H64.2148V71.4H60.835V68Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.835 64.5977H64.2148V67.9977H60.835V64.5977Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.835 61.1992H64.2148V64.5992H60.835V61.1992Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.835 57.7969H64.2148V61.1969H60.835V57.7969Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.835 54.3984H64.2148V57.7984H60.835V54.3984Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2178 78.1992H67.5977V81.5992H64.2178V78.1992Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2178 74.7969H67.5977V78.1969H64.2178V74.7969Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2178 71.3984H67.5977V74.7984H64.2178V71.3984Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2178 68H67.5977V71.4H64.2178V68Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2178 64.5977H67.5977V67.9977H64.2178V64.5977Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2178 61.1992H67.5977V64.5992H64.2178V61.1992Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2178 57.7969H67.5977V61.1969H64.2178V57.7969Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2178 54.3984H67.5977V57.7984H64.2178V54.3984Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5967 95.1992H70.9766V98.5992H67.5967V95.1992Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5967 91.7969H70.9766V95.1969H67.5967V91.7969Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5967 88.3984H70.9766V91.7984H67.5967V88.3984Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5967 85H70.9766V88.4H67.5967V85Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5967 81.5977H70.9766V84.9977H67.5967V81.5977Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5967 78.1992H70.9766V81.5992H67.5967V78.1992Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5967 74.7969H70.9766V78.1969H67.5967V74.7969Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5967 57.7969H70.9766V61.1969H67.5967V57.7969Z",
    fill: "#F7B88B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5967 54.3984H70.9766V57.7984H67.5967V54.3984Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9756 54.3984H74.3555V57.7984H70.9756V54.3984Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8077 88.3984H86.1875V91.7984H82.8077V88.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8077 85H86.1875V88.4H82.8077V85Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8077 81.6016H86.1875V85.0016H82.8077V81.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1866 91.8008H89.5664V95.2008H86.1866V91.8008Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1866 78.1992H89.5664V81.5992H86.1866V78.1992Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5655 91.8008H92.9453V95.2008H89.5655V91.8008Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9444 95.1992H96.3242V98.5992H92.9444V95.1992Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3272 95.1992H99.707V98.5992H96.3272V95.1992Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7061 95.1992H103.086V98.5992H99.7061V95.1992Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.085 98.6016H106.465V102.002H103.085V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.464 98.6016H109.844V102.002H106.464V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.464 78.1992H109.844V81.5992H106.464V78.1992Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.464 74.8008H109.844V78.2008H106.464V74.8008Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.464 71.3984H109.844V74.7984H106.464V71.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.464 68H109.844V71.4H106.464V68Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.847 98.6016H113.227V102.002H109.847V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.847 85H113.227V88.4H109.847V85Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.847 81.6016H113.227V85.0016H109.847V81.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.847 78.1992H113.227V81.5992H109.847V78.1992Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.847 74.8008H113.227V78.2008H109.847V74.8008Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.847 71.3984H113.227V74.7984H109.847V71.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.847 68H113.227V71.4H109.847V68Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.847 64.6016H113.227V68.0016H109.847V64.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.226 98.6016H116.605V102.002H113.226V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.226 85H116.605V88.4H113.226V85Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.226 81.6016H116.605V85.0016H113.226V81.6016Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.226 78.1992H116.605V81.5992H113.226V78.1992Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.226 74.8008H116.605V78.2008H113.226V74.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.226 71.3984H116.605V74.7984H113.226V71.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.226 68H116.605V71.4H113.226V68Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.226 64.6016H116.605V68.0016H113.226V64.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.605 98.6016H119.984V102.002H116.605V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.605 88.3984H119.984V91.7984H116.605V88.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.605 85H119.984V88.4H116.605V85Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.605 81.6016H119.984V85.0016H116.605V81.6016Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.605 78.1992H119.984V81.5992H116.605V78.1992Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.605 74.8008H119.984V78.2008H116.605V74.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.605 71.3984H119.984V74.7984H116.605V71.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.605 68H119.984V71.4H116.605V68Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.605 64.6016H119.984V68.0016H116.605V64.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.983 98.6016H123.363V102.002H119.983V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.983 88.3984H123.363V91.7984H119.983V88.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.983 85H123.363V88.4H119.983V85Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.983 81.6016H123.363V85.0016H119.983V81.6016Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.983 78.1992H123.363V81.5992H119.983V78.1992Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.983 74.8008H123.363V78.2008H119.983V74.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.983 71.3984H123.363V74.7984H119.983V71.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.983 68H123.363V71.4H119.983V68Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.366 98.6016H126.746V102.002H123.366V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.366 88.3984H126.746V91.7984H123.366V88.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.366 85H126.746V88.4H123.366V85Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.366 81.6016H126.746V85.0016H123.366V81.6016Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.366 78.1992H126.746V81.5992H123.366V78.1992Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.366 74.8008H126.746V78.2008H123.366V74.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.366 71.3984H126.746V74.7984H123.366V71.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.745 98.6016H130.125V102.002H126.745V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.745 95.1992H130.125V98.5992H126.745V95.1992Z",
    fill: "#F96E16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.745 91.8008H130.125V95.2008H126.745V91.8008Z",
    fill: "#F96E16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.745 88.3984H130.125V91.7984H126.745V88.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.745 85H130.125V88.4H126.745V85Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.745 81.6016H130.125V85.0016H126.745V81.6016Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.745 78.1992H130.125V81.5992H126.745V78.1992Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.745 74.8008H130.125V78.2008H126.745V74.8008Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.124 98.6016H133.504V102.002H130.124V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.124 88.3984H133.504V91.7984H130.124V88.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.124 85H133.504V88.4H130.124V85Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.124 81.6016H133.504V85.0016H130.124V81.6016Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.124 78.1992H133.504V81.5992H130.124V78.1992Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.124 74.8008H133.504V78.2008H130.124V74.8008Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.124 57.8008H133.504V61.2008H130.124V57.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.124 30.6016H133.504V34.0016H130.124V30.6016Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.124 27.1992H133.504V30.5992H130.124V27.1992Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.124 23.8008H133.504V27.2008H130.124V23.8008Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.503 98.6016H136.883V102.002H133.503V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.503 88.3984H136.883V91.7984H133.503V88.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.503 85H136.883V88.4H133.503V85Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.503 81.6016H136.883V85.0016H133.503V81.6016Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.503 78.1992H136.883V81.5992H133.503V78.1992Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.503 74.8008H136.883V78.2008H133.503V74.8008Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.503 71.3984H136.883V74.7984H133.503V71.3984Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.503 68H136.883V71.4H133.503V68Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.503 64.6016H136.883V68.0016H133.503V64.6016Z",
    fill: "#A60702"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.503 61.1992H136.883V64.5992H133.503V61.1992Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.503 57.8008H136.883V61.2008H133.503V57.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.503 54.3984H136.883V57.7984H133.503V54.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.503 34H136.883V37.4H133.503V34Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.503 30.6016H136.883V34.0016H133.503V30.6016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.503 27.1992H136.883V30.5992H133.503V27.1992Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.503 23.8008H136.883V27.2008H133.503V23.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.503 20.3984H136.883V23.7984H133.503V20.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.882 98.6016H140.262V102.002H136.882V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.882 88.3984H140.262V91.7984H136.882V88.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.882 85H140.262V88.4H136.882V85Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.882 81.6016H140.262V85.0016H136.882V81.6016Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.882 78.1992H140.262V81.5992H136.882V78.1992Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.882 74.8008H140.262V78.2008H136.882V74.8008Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.882 71.3984H140.262V74.7984H136.882V71.3984Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.882 68H140.262V71.4H136.882V68Z",
    fill: "#A60702"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.882 64.6016H140.262V68.0016H136.882V64.6016Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.882 61.1992H140.262V64.5992H136.882V61.1992Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.882 57.8008H140.262V61.2008H136.882V57.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.882 54.3984H140.262V57.7984H136.882V54.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.882 37.3984H140.262V40.7984H136.882V37.3984Z",
    fill: "#A60702"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.882 34H140.262V37.4H136.882V34Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.882 30.6016H140.262V34.0016H136.882V30.6016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.882 27.1992H140.262V30.5992H136.882V27.1992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.882 23.8008H140.262V27.2008H136.882V23.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.265 98.6016H143.645V102.002H140.265V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.265 88.3984H143.645V91.7984H140.265V88.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.265 85H143.645V88.4H140.265V85Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.265 81.6016H143.645V85.0016H140.265V81.6016Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.265 78.1992H143.645V81.5992H140.265V78.1992Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.265 71.3984H143.645V74.7984H140.265V71.3984Z",
    fill: "#A60702"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.265 68H143.645V71.4H140.265V68Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.265 64.6016H143.645V68.0016H140.265V64.6016Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.265 61.1992H143.645V64.5992H140.265V61.1992Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.265 57.8008H143.645V61.2008H140.265V57.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.265 54.3984H143.645V57.7984H140.265V54.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.265 51H143.645V54.4H140.265V51Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.265 47.6016H143.645V51.0016H140.265V47.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.265 40.8008H143.645V44.2008H140.265V40.8008Z",
    fill: "#A60702"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.265 37.3984H143.645V40.7984H140.265V37.3984Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.265 34H143.645V37.4H140.265V34Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.265 30.6016H143.645V34.0016H140.265V30.6016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.265 27.1992H143.645V30.5992H140.265V27.1992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.265 23.8008H143.645V27.2008H140.265V23.8008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.644 98.6016H147.023V102.002H143.644V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.644 88.3984H147.023V91.7984H143.644V88.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.644 85H147.023V88.4H143.644V85Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.644 81.6016H147.023V85.0016H143.644V81.6016Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.644 78.1992H147.023V81.5992H143.644V78.1992Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.644 71.3984H147.023V74.7984H143.644V71.3984Z",
    fill: "#A60702"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.644 68H147.023V71.4H143.644V68Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.644 64.6016H147.023V68.0016H143.644V64.6016Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.644 61.1992H147.023V64.5992H143.644V61.1992Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.644 57.8008H147.023V61.2008H143.644V57.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.644 54.3984H147.023V57.7984H143.644V54.3984Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.644 51H147.023V54.4H143.644V51Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.644 47.6016H147.023V51.0016H143.644V47.6016Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.644 44.1992H147.023V47.5992H143.644V44.1992Z",
    fill: "#A60702"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.644 40.8008H147.023V44.2008H143.644V40.8008Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.644 37.3984H147.023V40.7984H143.644V37.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.644 34H147.023V37.4H143.644V34Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.644 30.6016H147.023V34.0016H143.644V30.6016Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.644 27.1992H147.023V30.5992H143.644V27.1992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.022 98.6016H150.402V102.002H147.022V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.022 88.3984H150.402V91.7984H147.022V88.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.022 85H150.402V88.4H147.022V85Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.022 81.6016H150.402V85.0016H147.022V81.6016Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.022 78.1992H150.402V81.5992H147.022V78.1992Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.022 74.8008H150.402V78.2008H147.022V74.8008Z",
    fill: "#A60702"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.022 71.3984H150.402V74.7984H147.022V71.3984Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.022 68H150.402V71.4H147.022V68Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.022 64.6016H150.402V68.0016H147.022V64.6016Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.022 61.1992H150.402V64.5992H147.022V61.1992Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.022 57.8008H150.402V61.2008H147.022V57.8008Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.022 54.3984H150.402V57.7984H147.022V54.3984Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.022 51H150.402V54.4H147.022V51Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.022 47.6016H150.402V51.0016H147.022V47.6016Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.022 44.1992H150.402V47.5992H147.022V44.1992Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.022 40.8008H150.402V44.2008H147.022V40.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.022 37.3984H150.402V40.7984H147.022V37.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.022 34H150.402V37.4H147.022V34Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.022 30.6016H150.402V34.0016H147.022V30.6016Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.401 98.6016H153.781V102.002H150.401V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.401 88.3984H153.781V91.7984H150.401V88.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.401 85H153.781V88.4H150.401V85Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.401 81.6016H153.781V85.0016H150.401V81.6016Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.401 78.1992H153.781V81.5992H150.401V78.1992Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.401 71.3984H153.781V74.7984H150.401V71.3984Z",
    fill: "#A60702"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.401 68H153.781V71.4H150.401V68Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.401 64.6016H153.781V68.0016H150.401V64.6016Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.401 61.1992H153.781V64.5992H150.401V61.1992Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.401 57.8008H153.781V61.2008H150.401V57.8008Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.401 54.3984H153.781V57.7984H150.401V54.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.401 51H153.781V54.4H150.401V51Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.401 47.6016H153.781V51.0016H150.401V47.6016Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.401 44.1992H153.781V47.5992H150.401V44.1992Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.401 40.8008H153.781V44.2008H150.401V40.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.401 37.3984H153.781V40.7984H150.401V37.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.401 34H153.781V37.4H150.401V34Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.784 98.6016H157.164V102.002H153.784V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.784 88.3984H157.164V91.7984H153.784V88.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.784 85H157.164V88.4H153.784V85Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.784 81.6016H157.164V85.0016H153.784V81.6016Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.784 78.1992H157.164V81.5992H153.784V78.1992Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.784 68H157.164V71.4H153.784V68Z",
    fill: "#A60702"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.784 64.6016H157.164V68.0016H153.784V64.6016Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.784 61.1992H157.164V64.5992H153.784V61.1992Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.784 57.8008H157.164V61.2008H153.784V57.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.784 54.3984H157.164V57.7984H153.784V54.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.784 51H157.164V54.4H153.784V51Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.784 47.6016H157.164V51.0016H153.784V47.6016Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.784 44.1992H157.164V47.5992H153.784V44.1992Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.784 40.8008H157.164V44.2008H153.784V40.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.784 37.3984H157.164V40.7984H153.784V37.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.784 34H157.164V37.4H153.784V34Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.784 30.6016H157.164V34.0016H153.784V30.6016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.163 98.6016H160.543V102.002H157.163V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.163 95.1992H160.543V98.5992H157.163V95.1992Z",
    fill: "#F96E16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.163 91.8008H160.543V95.2008H157.163V91.8008Z",
    fill: "#F96E16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.163 88.3984H160.543V91.7984H157.163V88.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.163 85H160.543V88.4H157.163V85Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.163 81.6016H160.543V85.0016H157.163V81.6016Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.163 78.1992H160.543V81.5992H157.163V78.1992Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.163 74.8008H160.543V78.2008H157.163V74.8008Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.163 68H160.543V71.4H157.163V68Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.163 64.6016H160.543V68.0016H157.163V64.6016Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.163 61.1992H160.543V64.5992H157.163V61.1992Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.163 57.8008H160.543V61.2008H157.163V57.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.163 54.3984H160.543V57.7984H157.163V54.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.163 51H160.543V54.4H157.163V51Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.163 47.6016H160.543V51.0016H157.163V47.6016Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.163 44.1992H160.543V47.5992H157.163V44.1992Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.163 40.8008H160.543V44.2008H157.163V40.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.163 37.3984H160.543V40.7984H157.163V37.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.163 34H160.543V37.4H157.163V34Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.163 30.6016H160.543V34.0016H157.163V30.6016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.163 17H160.543V20.4H157.163V17Z",
    fill: "#F7B88B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.542 98.6016H163.922V102.002H160.542V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.542 95.1992H163.922V98.5992H160.542V95.1992Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.542 91.8008H163.922V95.2008H160.542V91.8008Z",
    fill: "#F96E16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.542 88.3984H163.922V91.7984H160.542V88.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.542 85H163.922V88.4H160.542V85Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.542 81.6016H163.922V85.0016H160.542V81.6016Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.542 78.1992H163.922V81.5992H160.542V78.1992Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.542 74.8008H163.922V78.2008H160.542V74.8008Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.542 68H163.922V71.4H160.542V68Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.542 64.6016H163.922V68.0016H160.542V64.6016Z",
    fill: "#A60702"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.542 61.1992H163.922V64.5992H160.542V61.1992Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.542 57.8008H163.922V61.2008H160.542V57.8008Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.542 54.3984H163.922V57.7984H160.542V54.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.542 51H163.922V54.4H160.542V51Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.542 47.6016H163.922V51.0016H160.542V47.6016Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.542 44.1992H163.922V47.5992H160.542V44.1992Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.542 40.8008H163.922V44.2008H160.542V40.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.542 37.3984H163.922V40.7984H160.542V37.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.542 34H163.922V37.4H160.542V34Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.542 30.6016H163.922V34.0016H160.542V30.6016Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.542 27.1992H163.922V30.5992H160.542V27.1992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.542 23.8008H163.922V27.2008H160.542V23.8008Z",
    fill: "#C24A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.542 20.3984H163.922V23.7984H160.542V20.3984Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.542 17H163.922V20.4H160.542V17Z",
    fill: "#F7B88B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.542 13.6016H163.922V17.0016H160.542V13.6016Z",
    fill: "#EAA275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.542 10.1992H163.922V13.5992H160.542V10.1992Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.542 6.80078H163.922V10.2008H160.542V6.80078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.921 98.6016H167.301V102.002H163.921V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.921 88.3984H167.301V91.7984H163.921V88.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.921 85H167.301V88.4H163.921V85Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.921 81.6016H167.301V85.0016H163.921V81.6016Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.921 78.1992H167.301V81.5992H163.921V78.1992Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.921 74.8008H167.301V78.2008H163.921V74.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.921 71.3984H167.301V74.7984H163.921V71.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.921 68H167.301V71.4H163.921V68Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.921 64.6016H167.301V68.0016H163.921V64.6016Z",
    fill: "#A60702"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.921 61.1992H167.301V64.5992H163.921V61.1992Z",
    fill: "#A60702"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.921 57.8008H167.301V61.2008H163.921V57.8008Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.921 54.3984H167.301V57.7984H163.921V54.3984Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.921 51H167.301V54.4H163.921V51Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.921 47.6016H167.301V51.0016H163.921V47.6016Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.921 44.1992H167.301V47.5992H163.921V44.1992Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.921 40.8008H167.301V44.2008H163.921V40.8008Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.921 37.3984H167.301V40.7984H163.921V37.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.921 34H167.301V37.4H163.921V34Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.921 30.6016H167.301V34.0016H163.921V30.6016Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.921 27.1992H167.301V30.5992H163.921V27.1992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.921 23.8008H167.301V27.2008H163.921V23.8008Z",
    fill: "#DD8C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.921 20.3984H167.301V23.7984H163.921V20.3984Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.921 17H167.301V20.4H163.921V17Z",
    fill: "#F7B88B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.921 13.6016H167.301V17.0016H163.921V13.6016Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.921 10.1992H167.301V13.5992H163.921V10.1992Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.921 6.80078H167.301V10.2008H163.921V6.80078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.921 3.39844H167.301V6.79844H163.921V3.39844Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.304 98.6016H170.684V102.002H167.304V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.304 88.3984H170.684V91.7984H167.304V88.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.304 85H170.684V88.4H167.304V85Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.304 81.6016H170.684V85.0016H167.304V81.6016Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.304 78.1992H170.684V81.5992H167.304V78.1992Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.304 74.8008H170.684V78.2008H167.304V74.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.304 71.3984H170.684V74.7984H167.304V71.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.304 68H170.684V71.4H167.304V68Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.304 64.6016H170.684V68.0016H167.304V64.6016Z",
    fill: "#A60702"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.304 61.1992H170.684V64.5992H167.304V61.1992Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.304 57.8008H170.684V61.2008H167.304V57.8008Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.304 54.3984H170.684V57.7984H167.304V54.3984Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.304 51H170.684V54.4H167.304V51Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.304 47.6016H170.684V51.0016H167.304V47.6016Z",
    fill: "#875A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.304 44.1992H170.684V47.5992H167.304V44.1992Z",
    fill: "#875A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.304 40.8008H170.684V44.2008H167.304V40.8008Z",
    fill: "#875A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.304 37.3984H170.684V40.7984H167.304V37.3984Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.304 34H170.684V37.4H167.304V34Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.304 30.6016H170.684V34.0016H167.304V30.6016Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.304 27.1992H170.684V30.5992H167.304V27.1992Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.304 23.8008H170.684V27.2008H167.304V23.8008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.304 20.3984H170.684V23.7984H167.304V20.3984Z",
    fill: "#EAA275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.304 17H170.684V20.4H167.304V17Z",
    fill: "#F7B88B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.304 13.6016H170.684V17.0016H167.304V13.6016Z",
    fill: "#EAA275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.304 10.1992H170.684V13.5992H167.304V10.1992Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.304 6.80078H170.684V10.2008H167.304V6.80078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.304 3.39844H170.684V6.79844H167.304V3.39844Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.304 0H170.684V3.4H167.304V0Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.683 98.6016H174.062V102.002H170.683V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.683 88.3984H174.062V91.7984H170.683V88.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.683 85H174.062V88.4H170.683V85Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.683 81.6016H174.062V85.0016H170.683V81.6016Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.683 78.1992H174.062V81.5992H170.683V78.1992Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.683 74.8008H174.062V78.2008H170.683V74.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.683 71.3984H174.062V74.7984H170.683V71.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.683 68H174.062V71.4H170.683V68Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.683 64.6016H174.062V68.0016H170.683V64.6016Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.683 61.1992H174.062V64.5992H170.683V61.1992Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.683 57.8008H174.062V61.2008H170.683V57.8008Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.683 54.3984H174.062V57.7984H170.683V54.3984Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.683 51H174.062V54.4H170.683V51Z",
    fill: "#875A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.683 47.6016H174.062V51.0016H170.683V47.6016Z",
    fill: "#875A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.683 44.1992H174.062V47.5992H170.683V44.1992Z",
    fill: "#875A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.683 40.8008H174.062V44.2008H170.683V40.8008Z",
    fill: "#875A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.683 37.3984H174.062V40.7984H170.683V37.3984Z",
    fill: "#875A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.683 34H174.062V37.4H170.683V34Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.683 30.6016H174.062V34.0016H170.683V30.6016Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.683 27.1992H174.062V30.5992H170.683V27.1992Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.683 23.8008H174.062V27.2008H170.683V23.8008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.683 20.3984H174.062V23.7984H170.683V20.3984Z",
    fill: "#EAA275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.683 17H174.062V20.4H170.683V17Z",
    fill: "#EAA275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.683 13.6016H174.062V17.0016H170.683V13.6016Z",
    fill: "#EAA275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.683 10.1992H174.062V13.5992H170.683V10.1992Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.683 6.80078H174.062V10.2008H170.683V6.80078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.683 3.39844H174.062V6.79844H170.683V3.39844Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.683 0H174.062V3.4H170.683V0Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.062 98.6016H177.441V102.002H174.062V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.062 88.3984H177.441V91.7984H174.062V88.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.062 85H177.441V88.4H174.062V85Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.062 81.6016H177.441V85.0016H174.062V81.6016Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.062 78.1992H177.441V81.5992H174.062V78.1992Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.062 74.8008H177.441V78.2008H174.062V74.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.062 71.3984H177.441V74.7984H174.062V71.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.062 68H177.441V71.4H174.062V68Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.062 64.6016H177.441V68.0016H174.062V64.6016Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.062 61.1992H177.441V64.5992H174.062V61.1992Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.062 57.8008H177.441V61.2008H174.062V57.8008Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.062 54.3984H177.441V57.7984H174.062V54.3984Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.062 51H177.441V54.4H174.062V51Z",
    fill: "#875A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.062 47.6016H177.441V51.0016H174.062V47.6016Z",
    fill: "#875A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.062 44.1992H177.441V47.5992H174.062V44.1992Z",
    fill: "#875A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.062 40.8008H177.441V44.2008H174.062V40.8008Z",
    fill: "#875A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.062 37.3984H177.441V40.7984H174.062V37.3984Z",
    fill: "#875A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.062 34H177.441V37.4H174.062V34Z",
    fill: "#875A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.062 30.6016H177.441V34.0016H174.062V30.6016Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.062 27.1992H177.441V30.5992H174.062V27.1992Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.062 23.8008H177.441V27.2008H174.062V23.8008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.062 20.3984H177.441V23.7984H174.062V20.3984Z",
    fill: "#EAA275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.062 17H177.441V20.4H174.062V17Z",
    fill: "#EAA275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.062 13.6016H177.441V17.0016H174.062V13.6016Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.062 10.1992H177.441V13.5992H174.062V10.1992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.062 6.80078H177.441V10.2008H174.062V6.80078Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.062 3.39844H177.441V6.79844H174.062V3.39844Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.062 0H177.441V3.4H174.062V0Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44 98.6016H180.82V102.002H177.44V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44 88.3984H180.82V91.7984H177.44V88.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44 85H180.82V88.4H177.44V85Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44 81.6016H180.82V85.0016H177.44V81.6016Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44 78.1992H180.82V81.5992H177.44V78.1992Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44 74.8008H180.82V78.2008H177.44V74.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44 71.3984H180.82V74.7984H177.44V71.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44 68H180.82V71.4H177.44V68Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44 64.6016H180.82V68.0016H177.44V64.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44 61.1992H180.82V64.5992H177.44V61.1992Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44 57.8008H180.82V61.2008H177.44V57.8008Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44 54.3984H180.82V57.7984H177.44V54.3984Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44 51H180.82V54.4H177.44V51Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44 47.6016H180.82V51.0016H177.44V47.6016Z",
    fill: "#875A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44 44.1992H180.82V47.5992H177.44V44.1992Z",
    fill: "#875A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44 40.8008H180.82V44.2008H177.44V40.8008Z",
    fill: "#875A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44 37.3984H180.82V40.7984H177.44V37.3984Z",
    fill: "#875A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44 34H180.82V37.4H177.44V34Z",
    fill: "#875A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44 30.6016H180.82V34.0016H177.44V30.6016Z",
    fill: "#875A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44 27.1992H180.82V30.5992H177.44V27.1992Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44 23.8008H180.82V27.2008H177.44V23.8008Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44 20.3984H180.82V23.7984H177.44V20.3984Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44 17H180.82V20.4H177.44V17Z",
    fill: "#875A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44 13.6016H180.82V17.0016H177.44V13.6016Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44 10.1992H180.82V13.5992H177.44V10.1992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44 6.80078H180.82V10.2008H177.44V6.80078Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44 3.39844H180.82V6.79844H177.44V3.39844Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44 0H180.82V3.4H177.44V0Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.823 98.6016H184.203V102.002H180.823V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.823 88.3984H184.203V91.7984H180.823V88.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.823 85H184.203V88.4H180.823V85Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.823 81.6016H184.203V85.0016H180.823V81.6016Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.823 78.1992H184.203V81.5992H180.823V78.1992Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.823 74.8008H184.203V78.2008H180.823V74.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.823 71.3984H184.203V74.7984H180.823V71.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.823 68H184.203V71.4H180.823V68Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.823 64.6016H184.203V68.0016H180.823V64.6016Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.823 61.1992H184.203V64.5992H180.823V61.1992Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.823 57.8008H184.203V61.2008H180.823V57.8008Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.823 54.3984H184.203V57.7984H180.823V54.3984Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.823 51H184.203V54.4H180.823V51Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.823 47.6016H184.203V51.0016H180.823V47.6016Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.823 44.1992H184.203V47.5992H180.823V44.1992Z",
    fill: "#875A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.823 40.8008H184.203V44.2008H180.823V40.8008Z",
    fill: "#875A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.823 37.3984H184.203V40.7984H180.823V37.3984Z",
    fill: "#875A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.823 34H184.203V37.4H180.823V34Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.823 30.6016H184.203V34.0016H180.823V30.6016Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.823 27.1992H184.203V30.5992H180.823V27.1992Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.823 23.8008H184.203V27.2008H180.823V23.8008Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.823 20.3984H184.203V23.7984H180.823V20.3984Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.823 17H184.203V20.4H180.823V17Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.823 13.6016H184.203V17.0016H180.823V13.6016Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.823 10.1992H184.203V13.5992H180.823V10.1992Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.823 6.80078H184.203V10.2008H180.823V6.80078Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.823 3.39844H184.203V6.79844H180.823V3.39844Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.823 0H184.203V3.4H180.823V0Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.202 98.6016H187.582V102.002H184.202V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.202 88.3984H187.582V91.7984H184.202V88.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.202 85H187.582V88.4H184.202V85Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.202 81.6016H187.582V85.0016H184.202V81.6016Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.202 78.1992H187.582V81.5992H184.202V78.1992Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.202 74.8008H187.582V78.2008H184.202V74.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.202 71.3984H187.582V74.7984H184.202V71.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.202 68H187.582V71.4H184.202V68Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.202 64.6016H187.582V68.0016H184.202V64.6016Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.202 61.1992H187.582V64.5992H184.202V61.1992Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.202 57.8008H187.582V61.2008H184.202V57.8008Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.202 54.3984H187.582V57.7984H184.202V54.3984Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.202 51H187.582V54.4H184.202V51Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.202 47.6016H187.582V51.0016H184.202V47.6016Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.202 44.1992H187.582V47.5992H184.202V44.1992Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.202 40.8008H187.582V44.2008H184.202V40.8008Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.202 37.3984H187.582V40.7984H184.202V37.3984Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.202 34H187.582V37.4H184.202V34Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.202 30.6016H187.582V34.0016H184.202V30.6016Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.202 27.1992H187.582V30.5992H184.202V27.1992Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.202 23.8008H187.582V27.2008H184.202V23.8008Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.202 20.3984H187.582V23.7984H184.202V20.3984Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.202 17H187.582V20.4H184.202V17Z",
    fill: "#875A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.202 10.1992H187.582V13.5992H184.202V10.1992Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.202 6.80078H187.582V10.2008H184.202V6.80078Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.202 3.39844H187.582V6.79844H184.202V3.39844Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.581 98.6016H190.961V102.002H187.581V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.581 88.3984H190.961V91.7984H187.581V88.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.581 85H190.961V88.4H187.581V85Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.581 81.6016H190.961V85.0016H187.581V81.6016Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.581 78.1992H190.961V81.5992H187.581V78.1992Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.581 74.8008H190.961V78.2008H187.581V74.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.581 71.3984H190.961V74.7984H187.581V71.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.581 68H190.961V71.4H187.581V68Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.581 64.6016H190.961V68.0016H187.581V64.6016Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.581 61.1992H190.961V64.5992H187.581V61.1992Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.581 57.8008H190.961V61.2008H187.581V57.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.581 54.3984H190.961V57.7984H187.581V54.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.581 51H190.961V54.4H187.581V51Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.581 47.6016H190.961V51.0016H187.581V47.6016Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.581 44.1992H190.961V47.5992H187.581V44.1992Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.581 40.8008H190.961V44.2008H187.581V40.8008Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.581 37.3984H190.961V40.7984H187.581V37.3984Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.581 34H190.961V37.4H187.581V34Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.581 30.6016H190.961V34.0016H187.581V30.6016Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.581 27.1992H190.961V30.5992H187.581V27.1992Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.581 23.8008H190.961V27.2008H187.581V23.8008Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.581 20.3984H190.961V23.7984H187.581V20.3984Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.581 17H190.961V20.4H187.581V17Z",
    fill: "#875A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.581 6.80078H190.961V10.2008H187.581V6.80078Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.96 98.6016H194.34V102.002H190.96V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.96 95.1992H194.34V98.5992H190.96V95.1992Z",
    fill: "#F96E16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.96 91.8008H194.34V95.2008H190.96V91.8008Z",
    fill: "#F96E16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.96 88.3984H194.34V91.7984H190.96V88.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.96 85H194.34V88.4H190.96V85Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.96 81.6016H194.34V85.0016H190.96V81.6016Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.96 78.1992H194.34V81.5992H190.96V78.1992Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.96 74.8008H194.34V78.2008H190.96V74.8008Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.96 71.3984H194.34V74.7984H190.96V71.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.96 68H194.34V71.4H190.96V68Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.96 64.6016H194.34V68.0016H190.96V64.6016Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.96 61.1992H194.34V64.5992H190.96V61.1992Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.96 57.8008H194.34V61.2008H190.96V57.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.96 54.3984H194.34V57.7984H190.96V54.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.96 51H194.34V54.4H190.96V51Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.96 47.6016H194.34V51.0016H190.96V47.6016Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.96 44.1992H194.34V47.5992H190.96V44.1992Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.96 40.8008H194.34V44.2008H190.96V40.8008Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.96 37.3984H194.34V40.7984H190.96V37.3984Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.96 34H194.34V37.4H190.96V34Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.96 30.6016H194.34V34.0016H190.96V30.6016Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.96 27.1992H194.34V30.5992H190.96V27.1992Z",
    fill: "#F2C32C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.96 23.8008H194.34V27.2008H190.96V23.8008Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.96 20.3984H194.34V23.7984H190.96V20.3984Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.96 10.1992H194.34V13.5992H190.96V10.1992Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.96 6.80078H194.34V10.2008H190.96V6.80078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.343 98.6016H197.723V102.002H194.343V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.343 88.3984H197.723V91.7984H194.343V88.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.343 85H197.723V88.4H194.343V85Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.343 81.6016H197.723V85.0016H194.343V81.6016Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.343 78.1992H197.723V81.5992H194.343V78.1992Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.343 74.8008H197.723V78.2008H194.343V74.8008Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.343 71.3984H197.723V74.7984H194.343V71.3984Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.343 68H197.723V71.4H194.343V68Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.343 64.6016H197.723V68.0016H194.343V64.6016Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.343 61.1992H197.723V64.5992H194.343V61.1992Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.343 57.8008H197.723V61.2008H194.343V57.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.343 54.3984H197.723V57.7984H194.343V54.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.343 51H197.723V54.4H194.343V51Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.343 47.6016H197.723V51.0016H194.343V47.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.343 44.1992H197.723V47.5992H194.343V44.1992Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.343 40.8008H197.723V44.2008H194.343V40.8008Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.343 37.3984H197.723V40.7984H194.343V37.3984Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.343 34H197.723V37.4H194.343V34Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.343 30.6016H197.723V34.0016H194.343V30.6016Z",
    fill: "#F2C32C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.343 23.8008H197.723V27.2008H194.343V23.8008Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.343 20.3984H197.723V23.7984H194.343V20.3984Z",
    fill: "#875A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.343 10.1992H197.723V13.5992H194.343V10.1992Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.343 6.80078H197.723V10.2008H194.343V6.80078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.722 98.6016H201.102V102.002H197.722V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.722 85H201.102V88.4H197.722V85Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.722 81.6016H201.102V85.0016H197.722V81.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.722 78.1992H201.102V81.5992H197.722V78.1992Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.722 74.8008H201.102V78.2008H197.722V74.8008Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.722 71.3984H201.102V74.7984H197.722V71.3984Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.722 68H201.102V71.4H197.722V68Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.722 64.6016H201.102V68.0016H197.722V64.6016Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.722 61.1992H201.102V64.5992H197.722V61.1992Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.722 57.8008H201.102V61.2008H197.722V57.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.722 54.3984H201.102V57.7984H197.722V54.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.722 51H201.102V54.4H197.722V51Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.722 47.6016H201.102V51.0016H197.722V47.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.722 44.1992H201.102V47.5992H197.722V44.1992Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.722 40.8008H201.102V44.2008H197.722V40.8008Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.722 37.3984H201.102V40.7984H197.722V37.3984Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.722 34H201.102V37.4H197.722V34Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.722 30.6016H201.102V34.0016H197.722V30.6016Z",
    fill: "#F2C32C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.722 20.3984H201.102V23.7984H197.722V20.3984Z",
    fill: "#875A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.101 98.6016H204.48V102.002H201.101V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.101 78.1992H204.48V81.5992H201.101V78.1992Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.101 74.8008H204.48V78.2008H201.101V74.8008Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.101 71.3984H204.48V74.7984H201.101V71.3984Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.101 68H204.48V71.4H201.101V68Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.101 64.6016H204.48V68.0016H201.101V64.6016Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.101 61.1992H204.48V64.5992H201.101V61.1992Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.101 57.8008H204.48V61.2008H201.101V57.8008Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.101 54.3984H204.48V57.7984H201.101V54.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.101 51H204.48V54.4H201.101V51Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.101 47.6016H204.48V51.0016H201.101V47.6016Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.101 44.1992H204.48V47.5992H201.101V44.1992Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.101 40.8008H204.48V44.2008H201.101V40.8008Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.101 37.3984H204.48V40.7984H201.101V37.3984Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.101 34H204.48V37.4H201.101V34Z",
    fill: "#F2C32C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.101 27.1992H204.48V30.5992H201.101V27.1992Z",
    fill: "#F2C32C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.48 98.6016H207.859V102.002H204.48V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.48 71.3984H207.859V74.7984H204.48V71.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.48 68H207.859V71.4H204.48V68Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.48 64.6016H207.859V68.0016H204.48V64.6016Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.48 61.1992H207.859V64.5992H204.48V61.1992Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.48 57.8008H207.859V61.2008H204.48V57.8008Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.48 54.3984H207.859V57.7984H204.48V54.3984Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.48 51H207.859V54.4H204.48V51Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.48 47.6016H207.859V51.0016H204.48V47.6016Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.48 44.1992H207.859V47.5992H204.48V44.1992Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.48 40.8008H207.859V44.2008H204.48V40.8008Z",
    fill: "#734931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.48 34H207.859V37.4H204.48V34Z",
    fill: "#F2C32C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.48 27.1992H207.859V30.5992H204.48V27.1992Z",
    fill: "#F2C32C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.862 98.6016H211.242V102.002H207.862V98.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.862 64.6016H211.242V68.0016H207.862V64.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.862 61.1992H211.242V64.5992H207.862V61.1992Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.862 57.8008H211.242V61.2008H207.862V57.8008Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.862 54.3984H211.242V57.7984H207.862V54.3984Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.862 51H211.242V54.4H207.862V51Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.862 47.6016H211.242V51.0016H207.862V47.6016Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.862 44.1992H211.242V47.5992H207.862V44.1992Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.862 34H211.242V37.4H207.862V34Z",
    fill: "#F2C32C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.241 57.8008H214.621V61.2008H211.241V57.8008Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.241 54.3984H214.621V57.7984H211.241V54.3984Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.241 51H214.621V54.4H211.241V51Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.241 47.6016H214.621V51.0016H211.241V47.6016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.62 51H218V54.4H214.62V51Z",
    fill: "#F3DB29"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_901_1790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 218,
    height: 102,
    fill: "white",
    transform: "matrix(-1 0 0 1 218 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNySanta);
export default __webpack_public_path__ + "static/media/NY-santa.b7045b9393689a87853299de50d321df.svg";
export { ForwardRef as ReactComponent };